import { MyPagination } from "Components/MyPagination/MyPagination";
import { TableListPage } from "Components/TableListPage/MyTable";
import React, { useEffect, useRef, useState } from "react";
import { FiltersForAllProjects } from "./components/FiltersForAllProjects/FiltersForAllProjects";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  getAllProjectsThunk,
  selectProject,
} from "AppStore/Slices/ProjectSlice/ProjectSlice";
import { formatDate } from "Helpers/formatDate";
import { Tag } from "antd";

export const AllProjects = () => {
  const { total, currentPage, projectsList, isLoading } =
    useSelector(selectProject);
  const [searchValue, setSearchValue] = useState("");
  const [usersFilter, setUsersFilter] = useState([]);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const timeoutId = useRef();
  const onRowClick = (row) => {
    navigate(`/projects/${row.id}`);
  };

  const columns = [
    {
      title: "Назва",
      dataIndex: "title",
    },
    {
      title: "Статус",
      render: (_, record) => <Tag>{record.projectStatus?.status}</Tag>,
    },
    {
      title: "Інженер",
      render: (_, record) => record.createdByUser?.name,
    },
    {
      title: "Створено",
      render: (_, record) => formatDate(record.createdAt),
    },

    {
      title: "Останнє оновлення",
      render: (_, record) => formatDate(record.updatedAt),
    },
  ];
  const changeParams = (param, value) => {
    switch (param) {
      case "changeUsers":
        setUsersFilter(value);
        break;

      default:
        break;
    }
  };
  useEffect(() => {
    clearTimeout(timeoutId.current);
    if (searchValue) {
      timeoutId.current = setTimeout(() => {
        if (page === 1) {
          dispatch(
            getAllProjectsThunk({
              searchValue,
              usersFilter: usersFilter.map((el) => el.id),
            }),
          );
        } else {
          dispatch(
            getAllProjectsThunk({
              page,
              searchValue,
              usersFilter: usersFilter.map((el) => el.id),
            }),
          );
        }
      }, 500);
      return;
    } else {
      dispatch(
        getAllProjectsThunk({
          page,
          usersFilter: usersFilter.map((el) => el.id),
        }),
      );
    }
  }, [page, searchValue, usersFilter]);

  return (
    <>
      <TableListPage
        isLoading={isLoading}
        mainTitle={"Всі проекти"}
        data={projectsList}
        columns={columns}
        onRowClick={onRowClick}
        showCreateButton={false}
        filters={() => (
          <FiltersForAllProjects
            value={usersFilter.map((el) => {
              return {
                value: JSON.stringify(el) + `___` + el.id,
                label: el.name,
              };
            })}
            onChange={(e) => {
              const userIds = (Array.isArray(e) ? e : [])
                .filter(Boolean)
                .map((el) => el?.value ?? el)
                .filter(Boolean);
              const usersData = userIds.map((user) => {
                const json = user.split("___")[0];
                const raw = JSON.parse(json);
                return raw;
              });

              changeParams("changeUsers", usersData);
            }}
          />
        )}
        setSearch={setSearchValue}
        search={searchValue}
      />

      <MyPagination
        totalItems={total}
        limit={10}
        isLoading={isLoading}
        currentPage={currentPage}
        changePage={setPage}
      />
    </>
  );
};
